Additional information related to branding that is accepted when posting a job ad.
